<!--  -->
<template>
    <div class="comp-checkbox flex_layout">
        <div class="checkbox-label flex_layout flex_y_center">
            <div class="label-dot"></div><span class="label-text">{{ label }}:</span>
        </div>
        <div class="flex_layout flex_wrap flex_y_center options-container">
            <div
                v-for="(item, index) in options"
                :key="'gender'+index"
                :class="`option-item first flex_layout flex_xy_center ${selectedOptions.includes(item.value) ? 'option-item--active' : ''}`"
                @click="selectOption(item.value)">
                <div
                    v-if="item.iconSrc"
                    class="option-icon">
                    <img :src="item.iconSrc" alt=""/>
                </div>
                <span class="option-name">{{item.label}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'compCheckbox',
    props: {
        options: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: ''
        },
        value: {
          type: Array,
          default: () => []
        }
    },
    data () {
        return {
            selectedOptions: []
        };
    },
    watch: {
        value: {
            immediate: true,
            handler (val) {
                this.selectedOptions = [...val];
            },
            deep: true
        }
    },
    created () {},
    mounted () {},
    methods: {
        selectOption (val) {
            const index = this.selectedOptions.findIndex(item => item === val);
            if (val === 0) {
                index === -1 ? this.selectedOptions = [val] : this.selectedOptions.splice(index, 1);
            }
            if (val !== 0) {
                const value0Index = this.selectedOptions.findIndex(item => item === 0);
                value0Index !== -1 && this.selectedOptions.splice(value0Index, 1);
                index === -1 ? this.selectedOptions.push(val) : this.selectedOptions.splice(index, 1);
            }
            this.$emit('input', this.selectedOptions);
        }
    },
};
</script>
<style lang="scss" scoped>
@import "@/css/common.scss";
.comp-checkbox{
    margin-top:vws(10px);
    padding-left:vws(45px);
    font-weight:500;
    color: #1E1E1E;
    align-items: flex-start;
    .checkbox-label{
        margin-right:vws(2px);
        height:vws(60px);
        .label-dot{
            width: vws(12px);
            height: vws(12px);
            background: #FFE120;
            border-radius: 50%;
            margin-right:vws(10px);
        }
        .label-text{
            font-size:vws(22px);
            transform: scale(0.92);
            transform-origin: left center;
            white-space: nowrap;
        }
    }
    .options-container{
        flex-wrap: wrap;
        .option-item{
            margin-bottom: vws(10px);
            cursor: pointer;
            font-size:0;
            margin-left:vws(27px);
            width:vws(114px);
            height:vws(60px);
            .option-icon{
                width:vws(49px);
                height:vws(40px);
                margin-right:vws(10px);
            }
            .option-name{
                font-size:vws(22px);
                transform: scale(0.92);
                transform-origin: center center;
                white-space: nowrap;
            }
        }
        .option-item--active{
            border: vws(2px) solid #FFE120;
            border-radius: vws(8px);
            font-weight:bold;
        }
    }
}
</style>